export default __webpack_public_path__ + "static/media/Weidmuller.5d2213c3.png";